<template>
  <v-chip
    v-if="status"
    small
    :color="style.color"
    :class="style.class"
    :dark="style.dark"
  >
    {{ localized ? $t(text) : text }}
  </v-chip>
</template>

<script>
import FLIGHT from '../../libs/consts/flight';

export default {
  props: {
    status: String,
    localized: Boolean,
  },

  computed: {
    text() {
      return FLIGHT.STATUS_MAPPINGS[this.status];
    },

    style() {
      return {
        [FLIGHT.STATUS.UNKNOWN]: {
          color: 'grey',
          class: 'lighten-2',
          dark: false,
        },
        [FLIGHT.STATUS.CANCELED]: {
          color: 'grey',
          class: null,
          dark: true,
        },
        [FLIGHT.STATUS.DELAYED]: {
          color: 'orange',
          class: null,
          dark: true,
        },
        [FLIGHT.STATUS.ON_TIME]: {
          color: 'green',
          class: null,
          dark: true,
        },
        [FLIGHT.STATUS.TIME_CHANGED]: {
          color: 'green',
          class: 'green lighten-3',
          dark: false,
        },
        [FLIGHT.STATUS.ARRIVED]: {
          color: 'info',
          class: null,
          dark: true,
        },
      }[this.status];
    }
  },
}
</script>
